// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"93":"list","177":"home","180":"story"}[chunkId] || chunkId) + "-" + {"93":"be770be875713e277fa6","177":"0f9b1cd8a0c1b0aa6ab1","180":"71518832cfcfa26e8f9d","585":"5e18d0b883967fb654be"}[chunkId] + ".css";
};